"use client"
import { FileText } from "lucide-react";
import { getConfidenceColor } from "./utils";

export default function ConfidenceAssessment({ confidenceAssessment }) {
    if (!confidenceAssessment) return null;

    return (
        <div className="pt-2">
            <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-2 sm:mb-3 flex items-center gap-2">
                <FileText className="w-4 h-4 sm:w-5 sm:h-5 text-[#0B7BC1] flex-shrink-0" />
                Confidence Assessment
            </h3>
            <div className="mb-2">
                <span className="text-xs sm:text-sm text-gray-600">Confidence Level: </span>
                <span className={`text-xs sm:text-sm font-semibold ${getConfidenceColor(confidenceAssessment.level)}`}>
                    {confidenceAssessment.level}
                </span>
            </div>
            {confidenceAssessment.limitations && (
                <div className="mt-2 sm:mt-3 p-2 sm:p-3 bg-yellow-50 border border-yellow-200 rounded-md">
                    <p className="text-xs sm:text-sm font-semibold text-yellow-900 mb-1">Limitations</p>
                    <p className="text-xs sm:text-sm text-yellow-800 break-words">{confidenceAssessment.limitations}</p>
                </div>
            )}
            {confidenceAssessment.assumptions && (
                <div className="mt-2 sm:mt-3 p-2 sm:p-3 bg-blue-50 border border-blue-200 rounded-md">
                    <p className="text-xs sm:text-sm font-semibold text-blue-900 mb-1">Assumptions</p>
                    <p className="text-xs sm:text-sm text-blue-800 break-words">{confidenceAssessment.assumptions}</p>
                </div>
            )}
        </div>
    );
}
